<template>
  <el-container id="barcode_oxxo" style="justify-content: center">
    <el-col
      class="main-wrapper"
      :xs="22"
      :sm="21"
      :md="14"
      :lg="12"
      :xl="12"
    >
      <el-row>
        <el-button
          type="primary"
          tag="button"
          @click="$goBack()"
          style="width:100%"
        >
          VOLVER
        </el-button>
      </el-row>
      <br>
      <el-row
        type="flex"
        justify="center"
      >
        <h2>CÓDIGO DE BARRAS DE PAGO</h2>
      </el-row>
      <el-row class="summary">
        <el-col>
          <dt>
            Referencia de pago:
          </dt>
          <dd>{{ reference }}</dd>

          <dt>
            Cuenta predial:
          </dt>
          <dd>{{ user.cuentadepredial }}</dd>

          <dt>
            Total A Pagar:
          </dt>
          <dd>
            {{ $currencyFormater(cart.total) }}
          </dd>
        </el-col>
      </el-row>
      <br><br>
      <el-row
        type="flex"
        id="code"
        justify="center"
      />
      <br>
      <el-row>
        <el-col>
          <router-link
            tag="button"
            to="/busqueda-del-predio"
            class="el-button el-button--primary"
            style="width:100%"
          >
            <span>
              CONSULTAR OTRA CUENTA
            </span>
          </router-link>
        </el-col>
      </el-row>
    </el-col>
  </el-container>
</template>

<script>
/* eslint-disable */

import JsBarcode from 'jsbarcode';
import { DOMImplementation, XMLSerializer } from 'xmldom';
import Moment from 'moment';
import { mapState } from 'vuex';

import generate from '../../utils/generateRef';

export default {
  data() {
    return {
      reference: '',
    };
  },
  computed: {
    ...mapState({
      cart: (state) => state.cart.data,
      user: (state) => state.predio.user,
    }),
  },
  methods: {
    generateRef() {
      const date = new Moment().format('DD/MM/YYYY');
      const ref = this.user.cuentadepredial;
      const { LINEA_OXXO } = generate(date, this.cart.total, ref);
      return LINEA_OXXO;
    },
    generateBarcode() {
      const xmlSerializer = new XMLSerializer();
      const doc = new DOMImplementation().createDocument('http://www.w3.org/1999/xhtml', 'html', null);
      const svgNode = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
      JsBarcode(svgNode, this.reference, {
        xmlDocument: doc,
        fontSize: 20,
      });
      let svgText = xmlSerializer.serializeToString(svgNode);
      const element = document.getElementById('code')
      element.innerHTML = svgText;
    },
  },
  mounted() {
    this.reference = this.generateRef();
    this.generateBarcode();
  },
};
</script>

<style lang="scss" scoped>
#barcode_oxxo {
  .el-button {
    background-color: #884E93;
    &:hover {
      opacity: 0.9;
    }
  }
  .main-wrapper {
    h2 {
      text-align: center;
    }
    .summary {
      background-color: #DCDFE7;
      border-radius: 10px;
      padding: 10px;
      margin-top:10px;
      dt {
        font-size: 14px;
        font-weight: bold;
        text-transform: uppercase;
        margin-top: 10px;
        &:first-child {
          margin-top: 0px !important;
        }
      }
      dd {
        color: #606266;
      }
    }
  }
}
</style>
